export default __webpack_public_path__ + "static/media/Patrec1.b87d4553.png";